import React from 'react'
import Button from '@material-ui/core/Button';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloseIcon from '@material-ui/icons/Close';
import './style.css'

const ErrorContent = ({ onClose }) => {
    return (
        <div className="modal-success-content-wrapper">
            <div className="modal-x-close-button-wrapper">
                <Button onClick={onClose}>
                    <CloseIcon />
                </Button>
            </div>
            <HighlightOffIcon color="secondary" style={{ fontSize: 80 }}/>
            <h3>Oops, something went wrong</h3>
            <p>Please contact Dan Toro!</p>
        </div>
    )
}

export default ErrorContent